export const ocrQualityMessages = {
  'zh-CN': {
    lowConfidence: '上次读到“{text}”，置信度 {confidence}，未达到 {minimumConfidence}。',
    failed: '上次等级读取未采用：{reason}。',
    retrying: '正在重试，请保持游戏画面可见。',
    minimumConfidence: '等级确认门槛',
    attempt: '等级尝试 {index}',
  },
  en: {
    lowConfidence: 'Last read “{text}” at {confidence} confidence; at least {minimumConfidence} is required.',
    failed: 'The last level reading was rejected: {reason}.',
    retrying: 'Retrying. Keep the game visible.',
    minimumConfidence: 'Level confidence threshold',
    attempt: 'Level attempt {index}',
  },
}
